import CardHighContent from '../../fragments/card/CardHighContent.jsx';
import CardHero from '../../fragments/card/CardHero.jsx';
import CardNews from '../../fragments/card/CardNews.jsx';

export default function CardItem({ card, cardType, index }) {
  // Event cards are news cards plus a date/time line, which CardNews renders
  // whenever the card data carries `eventDate`/`eventTime`.
  if (cardType === 'news' || cardType === 'event')
    return (
      <CardNews
        card={card}
        colorIndex={index}
        isEvent={cardType === 'event'}
      />
    );
  if (cardType === 'hero') return <CardHero card={card} colorIndex={index} />;
  if (cardType === 'high-content')
    return <CardHighContent card={card} colorIndex={index} />;
  return <CardHighContent card={card} colorIndex={index} />;
}
